import type { AppModule } from '@support/core';

import * as routes from './routes.js';

export const AuthModule: AppModule = {
  routes,
};
